import React, { useEffect, useState } from 'react';
import './Skills.css';
import AOS from 'aos';
import 'aos/dist/aos.css';

import html from '../../assets/images/html-5.png';
import css from '../../assets/images/css-3.png';
import react from '../../assets/images/React.png';
import nodejs from '../../assets/images/nodejs.png';
import firebase from '../../assets/images/firebase.png';
import netlify from '../../assets/images/Netlify.png';
import github from '../../assets/images/github.png';
import figma from '../../assets/images/figma.png';
import canva from '../../assets/images/canva.png';
import java from '../../assets/images/java image.jpg';
import kotlin from '../../assets/images/kotlin image.jpg';
import python from '../../assets/images/python image.jpg';
import mysql from '../../assets/images/mysql image.jpg';
import cloudflare from '../../assets/images/cloudflare image.jpg';
import springboot from '../../assets/images/springboot image.webp';
import javascript from '../../assets/images/JavaScript.png';
import mongodb from '../../assets/images/mongo-db.png';
import nextjs from '../../assets/images/nextjs.png';


const skillsData = [
  { name: 'HTML', image: html, percent: 95, category: 'Frontend' },
  { name: 'CSS', image: css, percent: 90, category: 'Frontend' },
  { name: 'JavaScript', image: javascript, percent: 80, category: 'Frontend' },
  { name: 'React', image: react, percent: 85, category: 'Frontend' },
  { name: 'Next.js', image: nextjs, percent: 50, category: 'Frontend' },
  { name: 'Node.js', image: nodejs, percent: 80, category: 'Backend' },
  { name: 'Firebase', image: firebase, percent: 75, category: 'Backend' },
  { name: 'Netlify', image: netlify, percent: 70, category: 'Deployment' },
  { name: 'GitHub', image: github, percent: 85, category: 'Tools' },
  { name: 'Figma', image: figma, percent: 90, category: 'Design' },
  { name: 'Canva', image: canva, percent: 88, category: 'Design' },
  { name: 'Java', image: java, percent: 60, category: 'Backend' },
  { name: 'Spring Boot', image: springboot, percent: 65, category: 'Backend' },
  { name: 'Kotlin', image: kotlin, percent: 30, category: 'Backend' },
  { name: 'Python', image: python, percent: 30, category: 'Backend' },
  { name: 'MySQL', image: mysql, percent: 50, category: 'Database' },
  { name: 'MongoDB', image: mongodb, percent: 50, category: 'Database' },
  { name: 'Cloudflare', image: cloudflare, percent: 50, category: 'Deployment' },
];



const categories = ['All', 'Frontend', 'Backend', 'Design', 'Tools', 'Deployment', 'Database'];

const Skills = () => {
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [searchTerm, setSearchTerm] = useState('');
  const [progressAnimated, setProgressAnimated] = useState(false);

  useEffect(() => {
    AOS.init({ duration: 1000 });
    const timeout = setTimeout(() => setProgressAnimated(true), 300);
    return () => clearTimeout(timeout);
  }, []);

  const filteredSkills = skillsData.filter(skill =>
    (selectedCategory === 'All' || skill.category === selectedCategory) &&
    skill.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="skills-container">
      <h1 className="skills-heading" data-aos="fade-down">
        <span>M</span><span>y</span> <span>S</span><span>k</span><span>i</span><span>l</span><span>l</span><span>s</span>
      </h1>

      <div className="skills-content">
        <div className="skills-filter" data-aos="fade-right">
          <label htmlFor="category">Filters</label>
          <select
            id="category"
            value={selectedCategory}
            onChange={(e) => setSelectedCategory(e.target.value)}
          >
            {categories.map((cat, i) => (
              <option key={i} value={cat}>{cat}</option>
            ))}
          </select>
          <input
            type="text"
            placeholder="Search skill..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <button className="clear-btn" onClick={() => { setSelectedCategory('All'); setSearchTerm(''); }}>
            Clear Filter
          </button>
        </div>

        <div className="skills-main">
          <h2 className="section-title" data-aos="fade-up">Technical Skills</h2>

          <div className="skills-grid">
            {filteredSkills.map((skill, index) => (
              <div className="skill-card" key={index} data-aos="zoom-in">
                <img src={skill.image} alt={skill.name} />
                <p>{skill.name}</p>
              </div>
            ))}
          </div>

          <div className="skills-progress-section">
            {filteredSkills.map((skill, index) => (
              <div className="progress-wrapper" key={index} data-aos="fade-up">
                <span>{skill.name}</span>
                <div className="progress-bar">
                  <div
                    className="progress-fill"
                    style={{ width: progressAnimated ? `${skill.percent}%` : '0%' }}
                  >
                    <span>{skill.percent}%</span>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <p className="skills-description" data-aos="fade-in">
            I am proficient in various frontend, backend, design, and database tools. These skills help me create full-fledged, responsive, and visually appealing web applications.
          </p>

          <a
            href="https://drive.google.com/file/d/1IRPkXFylnXo-lI1m4uSddA1n0DNeMntH/view?usp=sharing"
            target="_blank"
            rel="noopener noreferrer"
            className="view-btn"
            data-aos="zoom-in"
          >
            ➤ View Resume
          </a>
        </div>
      </div>
    </div>
  );
};

export default Skills;
